export const categories = [
  "All",
  "Full Stack",
  "Web Design",
  "Web Application",
];

export const projectsData = [
  {
    _id: "675c1809b127dcce71e03767",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691760/brainwaveacademy.vercel.app__jb96pb.png",
    title: "Brainwave Academy-EdTech",
    category: "Full Stack",
    description:
      "An educational platform built with Next.js and MongoDB, offering course management and interactive learning experiences.",
    tags: ["Next.js", "MongoDB", "TailwindCSS", "Node.js"],
    link: "https://brainwaveacademy.vercel.app",
    priority: 8,
  },
  {
    _id: "675c1809b127dcce71e055772",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691054/new_Projects/careerdoor_yirmkt.png",
    title: "Careerdoor – Ai Powered Job Aggregation Platform",
    category: "Web Application",
    description:
      "An all-in-one job search platform aggregating listings from LinkedIn, Indeed, Glassdoor, and more. Features AI-based resume scoring, smart filters, and automated job form filler extension.",
    tags: ["React", "Node.js", "TailwindCSS", "AI", "Web Scraping"],
    link: "https://www.careerdoor.in",
    priority: 7,
  },
  {
    _id: "675c1809b127dcce71e055775",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691065/new_Projects/mbbsroutes.com__a4ur4i.png",
    title: "MBBS Routes – MBBS Abroad Consultancy Platform",
    category: "Full Stack | SaaS",
    description:
      "A comprehensive platform guiding 1000+ students in their MBBS journey. Features include dashboard analytics, college filters, eligibility scoring, AWS hosting, and custom domain integration.",
    tags: ["MERN","AI", "AWS", "TailwindCSS", "Full Stack"],
    link: "https://mbbsroutes.com",
    priority: 6,
  },
  {
    _id: "675c1809b127dcce71e03768",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691069/new_Projects/cineflex-movies.vercel.app__xlavr9.png",
    title: "CineFlex Movies",
    category: "Full Stack",
    description:
      "A full-stack movie platform built with MERN stack. Features user authentication, movie browsing, and personalized watchlists.",
    tags: ["React", "Node.js", "MongoDB", "Express"],
    link: "https://cineflex-movies.vercel.app",
    priority: 5,
  },
  {
    _id: "675c1809b127dcce71e055773",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691060/new_Projects/Printit_zy1jhr.png",
    title: "Automated Printing System",
    category: "IoT | Patent",
    description:
      "A patent-pending automated printing solution enabling file submissions via chat/email/web, secure QR-based wireless transfer, dynamic scheduling, and real-time job updates — without cloud dependency.",
    tags: ["IoT", "Automation", "QR Code", "Local Server", "UPI", "Patent"],
    link: "https://printing-automation-project-link.com",
    priority: 4,
  },
  {
    _id: "675c1809b127dcce71e055771",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691050/new_Projects/Aicall_plgas1.png",
    title: "AI-Powered Customer Care Platform",
    category: "Hackathon | Full Stack",
    description:
      "A real-time customer care solution built for Vultr Cloud Hackathon, featuring AI-powered task management, RAG-based chatbots, and Agora-integrated video calls for seamless customer support.",
    tags: ["React", "Node.js", "Laravel", "Agora", "Vultr", "RAG", "AI"],
    link: "https://github.com/barhatemanthan/vultr_t2",
    priority: 3,
  },
  {
    _id: "675c1809b127dcce71e03769",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1728483934/Projects/j8fizb8tokltuuhy7svh.png",
    title: "Razerpay Clone",
    category: "Web Design",
    description:
      "A pixel-perfect clone of Razorpay's landing page using TailwindCSS, showcasing responsive design and modern UI practices.",
    tags: ["TailwindCSS", "HTML5", "CSS3", "JavaScript"],
    link: "https://omkarkhoche3448.github.io/Razorpay-Ui-Clone/",
    priority: 2,
  },
  {
    _id: "675c1809b127dcce71e055774",
    image:
      "https://res.cloudinary.com/dkbzscmmq/image/upload/v1752691056/new_Projects/brandiq_jbvwwq.png",
    title: "BrandIQ – Brand Analysis Agent",
    category: "AI | Automation | PDF Generation",
    description:
      "An AI-powered Agent that analyzes competitor websites to extract brand colors, fonts, and tone, generating a polished PDF brand style guide using OpenAI, BeautifulSoup, and ReportLab.",
    tags: ["Python", "OpenAI", "BeautifulSoup", "SQLite", "PDF", "Automation"],
    link: "https://github.com/omkarkhoche/brandIQ",
    priority: 1,
  },
];
